import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/logical-positions',
    name: 'logical-position',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/logical-position')
  }
]
